<template>
  <div class="price-detail" :data-ycq="ycq">
    <div class="item-layout">
      <div class="item-common-layout">
        <div class="item-common-content">
          <div class="block" @click="showExpect">
            <label class="label-ui"
              >{{ expect.label
              }}<span class="red" style="color: red">*</span></label
            >
            <div class="item-cell-bd">
              <div class="default" v-if="!expect.value">
                {{ expect.placeholder }}
              </div>
              <div v-else>
                <p>{{ expect.value }}</p>
              </div>
            </div>
          </div>
        </div>
        <div v-if="!isSignRenewOrder" class="icon-arr-r"></div>
      </div>
    </div>
    <div v-if="!helpSkhy" class="item-layout">
      <div class="item-common-layout">
        <div class="item-common-content">
          <div class="block">
            <label class="label-ui"
              >服务顾问<span class="red" style="color: red">*</span></label
            >
            <div class="item-cell-bd ye-gw-ui">
              <label :class="{ hasValue: !!fillIn.inviteCode }">
                <input
                  type="number"
                  placeholder="请填写育儿顾问工号"
                  maxlength="10"
                  :disabled="isSignRenewOrder"
                  @input="handleghInput($event)"
                  v-input-scroll
                  :value="fillIn.inviteCode"
                />
                <!-- <p class="gw-name">{{ fillIn.inviteName }}</p> -->
              </label>
            </div>
          </div>
        </div>
        <div v-if="!isSignRenewOrder" class="icon-arr-r"></div>
      </div>
    </div>
    <div class="item-layout user-remark-layout">
      <div class="item-common-layout user-remark">
        <div class="item-common-content">
          <div class="block">
            <label class="label-ui"
              >备注<span v-if="!helpSkhy" class="fff">(选填)</span></label
            >
            <textarea
              placeholder="请输入您的需求"
              v-model="fillIn.remark"
              v-input-scroll
              rows="3"
              :readonly="helpSkhy"
              @blur="handleLabel($event)"
            ></textarea>
          </div>
        </div>
      </div>
    </div>
    <mt-datetime-picker
      ref="picker"
      v-model="pickerVisible"
      type="date"
      :startDate="startDate"
      year-format="{value} 年"
      month-format="{value} 月"
      date-format="{value} 日"
      @confirm="handlePicker"
    >
    </mt-datetime-picker>
  </div>
</template>
<script>
import { mapState, mapMutations, mapActions } from 'vuex'
import { DatetimePicker } from 'mint-ui'

import utils from '@/plugins/utils'

import { trackClick } from '@/router/confirmYuesaoValetOrder/ys_ensure_service_tracker'
export default {
  components: {
    [DatetimePicker.name]: DatetimePicker
  },
  props: {
    fillIn: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      pickerVisible: null,
      startDate: new Date()
    }
  },
  mounted() {
    setTimeout(() => {
      console.log(
        'object :>> ',
        this.fillIn.serviceDaysReal,
        this.fillIn.serviceDays
      )
      if (
        this.helpSkhy ||
        this.fillIn.serviceDaysReal !== this.fillIn.serviceDays
      ) {
        this.fillIn.remark = `${
          this.fillIn.remark ? `${this.fillIn.remark},` : ''
        }实际服务天数${this.fillIn.serviceDaysReal}天`
      }
    }, 100)
  },
  computed: {
    //是否为续单订单
    isSignRenewOrder() {
      if (this.fillIn.isSignRenewOrder && this.fillIn.isSignRenewOrder == 1) {
        return true
      }
      return false
    },
    helpSkhy() {
      //商客代客下单
      if (this.fillIn.helpType && this.fillIn.helpType == 1) {
        return true
      }
      return false
    },
    ycq() {
      let value = this.expect.value ? this.expect.value : this.fillIn.ycq
      if (value) {
        this.setSelected({ id: 'ycq', value })
      }
      return value
    },
    ...mapState('confirmYuesao', ['depList']),
    ...mapState([
      'confirmProduct',
      'selectedCoupon',
      'selectedWorker',
      'selectedTime',
      'selectedAddress'
    ]),
    expect() {
      return this.depList.find(item => item.id === 'ycq')
    }
  },
  methods: {
    ...mapMutations('confirmYuesao', ['setSelected']),
    ...mapActions('confirmYuesao', ['verificationDepList', 'queryWorkerInfo']),
    async showExpect() {
      if (this.isSignRenewOrder) return
      const isValid = await this.verificationDepList('ycq')
      if (isValid) {
        this.$refs.picker.open()
      }
    },
    handlePicker(value) {
      trackClick('SUBMIT_MATERNITY')
      const dateText = utils.dateFormat(value, 'YY-MM-DD')
      console.log(111, dateText)
      this.setSelected({ id: 'ycq', value: dateText })
    },
    handleghInput(event) {
      trackClick('CHOOSE_ADVISER')
      const value = event.target.value
      this.fillIn.inviteCode = value
      if (value) {
        if (value.length === 8 && value.indexOf('19') === 0) {
          this.getYuerGwInfo(value)
        } else {
          this.fillIn.inviteName = ''
        }
      } else {
        this.fillIn.inviteName = ''
      }
    },
    handleLabel(event) {
      trackClick('REMARKS_REMARK')
    },
    async getYuerGwInfo(value) {
      const response = await this.queryWorkerInfo(value)

      if (response && response.code * 1 === 1 && response.data) {
        const res = response.data
        this.fillIn.inviteName = res.workerName
      } else {
        this.fillIn.inviteName = ''
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import '~@/assets/css/mixin';
.price-detail {
  background-color: #fff;
  border-radius: rem(16px);
  ul {
    padding: rem(40px) 0;
    li {
      line-height: rem(32px);
      &:first-child {
        margin-bottom: rem(20px);
      }
      > div {
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: rem(26px);
        color: #333333;
      }
      .coupon-ui {
        color: #ff395e;
      }
    }
  }
  .item-layout .item-common-content .item-cell-bd {
    p {
      font-weight: bold;
    }
  }
}
.block {
  input {
    line-height: rem(40px);
  }
}

.user-remark-layout {
  padding-right: 0;
  padding-top: rem(22px);
  padding-bottom: rem(18px);
  .item-common-layout {
    .item-common-content {
      .block {
        .label-ui {
          align-items: flex-start;
          padding-top: rem(22px);
        }
      }
    }
  }
}
.user-remark {
  @include border(bottom, #f2f2f2, 0);

  align-items: flex-start;
  textarea {
    text-align: left;
    padding-right: rem(24px);
    padding-top: rem(17px);
    margin-left: 0;
    resize: none;
    flex: auto;
    border: 0;
    line-height: rem(38px);
    color: #000000;
    font-size: rem(28px);
  }
}
.invite-code {
  color: #000000;
  font-size: rem(26px);
  input {
    text-align: right;
  }
}
.ye-gw-ui label {
  width: auto;
  display: flex;
  overflow: hidden;
  align-items: center;
  input {
    flex: none;
    width: auto;
  }
  .gw-name {
    font-weight: 700;
    flex: auto;
    @include ellicpsis;
  }
  &.hasValue input {
    width: rem(160px);
    &[type='number'] {
      font-weight: bold;
    }
  }
}
.fff {
  color: #999;
}
</style>
